import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';

const FAQ = () => {
  const faqs = [
    {
      question: 'Berapa biaya service water heater?',
      answer: 'Biaya service tergantung jenis kerusakan. Kami akan memberikan estimasi biaya setelah melakukan diagnosa awal. Konsultasi dan diagnosa awal gratis tanpa biaya.'
    },
    {
      question: 'Apakah spare part yang digunakan original?',
      answer: 'Ya, kami hanya menggunakan spare part original  untuk menjamin kualitas dan keawetan perbaikan. Semua spare part dilengkapi dengan garansi resmi.'
    },
    {
      question: 'Berapa lama waktu pengerjaan service?',
      answer: 'Untuk kerusakan ringan biasanya selesai dalam 1-2 jam. Untuk kerusakan yang memerlukan penggantian spare part, maksimal 1-2 hari kerja tergantung ketersediaan part.'
    },
    {
      question: 'Apakah ada garansi setelah service?',
      answer: 'Ya, kami memberikan garansi service selama 30 hari untuk workmanship dan garansi spare part sesuai dengan ketentuan dari .'
    },
    {
      question: 'Area mana saja yang dilayani?',
      answer: 'Kami melayani seluruh area Jabodetabek (Jakarta, Bogor, Depok, Tangerang, dan Bekasi) dengan layanan 24 jam setiap hari.'
    },
    {
      question: 'Bagaimana cara pembayaran?',
      answer: 'Kami menerima pembayaran tunai, transfer bank, dan e-wallet (GoPay, OVO, Dana). Pembayaran dilakukan setelah service selesai dan kompor sudah berfungsi dengan baik.'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          {/* Section Header */}
          <div className="text-center mb-16">
            <div className="inline-block bg-blue-100 text-blue-600 px-4 py-2 rounded-full text-sm font-semibold mb-4">
              FAQ
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
              Pertanyaan yang Sering Ditanyakan
            </h2>
            <p className="text-xl text-gray-600">
              Temukan jawaban untuk pertanyaan umum seputar layanan kami
            </p>
          </div>

          {/* FAQ Accordion */}
          <Accordion type="single" collapsible className="space-y-4">
            {faqs.map((faq, index) => (
              <AccordionItem
                key={index}
                value={`item-${index}`}
                className="border-2 border-gray-200 rounded-xl px-6 hover:border-blue-500 transition-colors duration-300"
              >
                <AccordionTrigger className="text-left text-lg font-semibold text-gray-900 hover:text-blue-600 py-6">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-gray-700 leading-relaxed pb-6">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};

export default FAQ;